/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Iap_Page_TitleInputs */

const en_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Plus Rewards and Get the Limited Land Style! `)
};

const ar_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح مكافآت Plus واحصل على نمط الأرضالمحدود!`)
};

const de_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-Belohnungen freischalten und die limitierte Land-Stilerhalten! `)
};

const es_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Desbloquea recompensas Plus y consigue el Estilo de terreno de edición limitada!`)
};

const fr_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez les récompenses Plus et obtenez le Style de sol en édition limitée !`)
};

const it_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca i premi Plus e ottieni lo Stile del terreno limitato! `)
};

const ja_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus報酬をアンロックして、限定ランドスタイルを手に入れよう！`)
};

const ko_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 리워드를 개방하고 한정판 랜드 스타일을 받으세요! `)
};

const pt_br_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueie as recompensas Plus e obtenha o Estilo de terreno, que é por tempo limitado!`)
};

const ru_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокируйте Plus-награды и получите лимитированный Стиль земли!`)
};

const th_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกรางวัล Plus และรับสไตล์พื้นดินแบบลิมิเต็ด!`)
};

const tr_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Ödüllerinin Kilidini Aç ve Sınırlı Sayıda Arazi Türü Edin!`)
};

const zh_cn_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即解锁 Plus 奖励
和限定土地皮肤`)
};

const zh_tw_focus_pass_iap_page_title = /** @type {(inputs: Focus_Pass_Iap_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即解鎖 Plus 獎勵
和限定土地造型`)
};

/**
* | output |
* | --- |
* | "Unlock Plus Rewards and Get the Limited Land Style!" |
*
* @param {Focus_Pass_Iap_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_iap_page_title = /** @type {((inputs?: Focus_Pass_Iap_Page_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Iap_Page_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_iap_page_title(inputs)
	if (locale === "ar") return ar_focus_pass_iap_page_title(inputs)
	if (locale === "de") return de_focus_pass_iap_page_title(inputs)
	if (locale === "es") return es_focus_pass_iap_page_title(inputs)
	if (locale === "fr") return fr_focus_pass_iap_page_title(inputs)
	if (locale === "it") return it_focus_pass_iap_page_title(inputs)
	if (locale === "ja") return ja_focus_pass_iap_page_title(inputs)
	if (locale === "ko") return ko_focus_pass_iap_page_title(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_iap_page_title(inputs)
	if (locale === "ru") return ru_focus_pass_iap_page_title(inputs)
	if (locale === "th") return th_focus_pass_iap_page_title(inputs)
	if (locale === "tr") return tr_focus_pass_iap_page_title(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_iap_page_title(inputs)
	return zh_tw_focus_pass_iap_page_title(inputs)
});